import React, { Component } from 'react'
import './masonryelement.scss'
class MasonryElement extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedID: 0
		}
	}

	selectAplication = (e) => {
		e.preventDefault()
		this.setState({ selectedID: e.currentTarget.dataset.id })
		e.stopPropagation()
	}

	sendSelectedId = (e) => {
		this.props.onClick(this.state)
	}

	render() {
		let classes = ['vbui--masonryelement', this.props.classes, this.props.state].join(' ')
		return (
			<div className={classes} onClick={this.sendSelectedId} id={this.props.data.family.familyId}>
				<div className="img-container">
					{this.props.data.applications[this.state.selectedID].images.length > 0 && (
						<img src={this.props.data.applications[this.state.selectedID].images[0].path} alt="" />
					)}
					{this.props.data.applications[this.state.selectedID].images.length === 0 && (
						<div className="default-image"></div>
					)}
				</div>

				<p className="element-title">{this.props.data.family.description}</p>
				<div className="aplication-selector-container">
					{this.props.data.applications.map((application, i) => {
						let isSelected = ''
						if (this.state.selectedID.toString() === i.toString()) {
							isSelected = 'active'
						}
						let tagClass = ['element-content', isSelected].join(' ')
						return (
							<a key={i} href="/" className={tagClass} data-id={i} onClick={this.selectAplication}>
								{application.location.name}
							</a>
						)
					})}
				</div>
			</div>
		)
	}
}
export default MasonryElement
